import { render, staticRenderFns } from "./DangerCctvPopup.vue?vue&type=template&id=2664b7c2&"
import script from "./DangerCctvPopup.vue?vue&type=script&lang=js&"
export * from "./DangerCctvPopup.vue?vue&type=script&lang=js&"
import style0 from "./DangerCctvPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2664b7c2')) {
      api.createRecord('2664b7c2', component.options)
    } else {
      api.reload('2664b7c2', component.options)
    }
    module.hot.accept("./DangerCctvPopup.vue?vue&type=template&id=2664b7c2&", function () {
      api.rerender('2664b7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DangerCctvPopup.vue"
export default component.exports